const scrollToId = (id: string | HTMLElement) => {
  const element = typeof id === 'string' ? document.getElementById(id) : id
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }
}

export default scrollToId
